/* TypeTopia — the words on a face confetti accessory, with emoji (v1, 2026-10-26)
   assets/tt-acc-text.js

   Ally (2026-10-25): "if emojis are typed, we need them to show"; "go with fluent". The face confetti section
   (sections/tt-face-confetti.liquid: face confetti, gift tags, shirt confetti) draws an accessory's words with the
   canvas's own text, which would draw an emoji in the device's own set (Apple's on an iPhone, which can never be printed)
   into the picture that prints. This draws the words as before and every emoji in Microsoft's Fluent set instead
   (window.TTEmoji, assets/tt-emoji.js, loaded before this): a 0.95 em square on the words' middle, 1.05 em along, in its
   own colours. One the set hasn't got (a flag) is left out, as are skin tones and joiners left on their own. An emoji's
   shapes are fetched the first time a text needs them; then window.TTAccTextReady() (the section's: everything drawn
   again) is called, and ready() resolves (the section waits for it before baking a face for the order).
     TTAccText.fill(cx, text, x, y, size)    as cx.fillText(text, x, y) with textAlign "center", textBaseline "middle"
     TTAccText.stroke(cx, text, x, y, size)  the keyline, as cx.strokeText: the words only (an emoji has none)
     TTAccText.halves(text)                  [first, second]: half the characters each, an emoji one (a split accessory)
     TTAccText.ready()                       a promise: every emoji asked for so far is in
   A text with no emoji is drawn exactly as before. */
(function (G) {
  "use strict";
  var SIZE = 0.95, ADV = 1.05;
  var PIC = /\p{Extended_Pictographic}|\p{Regional_Indicator}/u, LONE = /\p{Emoji_Modifier}|[‍️︎⃣]/u;
  var jobs = [], asked = {}, later = [];
  function M() { return G.TTEmoji || null; }
  /* a letter: anything that isn't a pictograph, and the old symbols a font may have (© ® ™) */
  function letter(c) { return c.codePointAt(0) < 0x2200 || !PIC.test(c); }
  function clean(t) { return Array.from(t).filter(function (c) { return letter(c) && !LONE.test(c); }).join(""); }
  function runs(s) {
    var m = M(), out = [];
    (m ? m.split(s, letter) : [{ t: "x", s: s }]).forEach(function (r) {
      if (r.t === "e") { out.push(r); return; }
      var t = clean(r.s);
      if (t) out.push({ t: "x", s: t });
    });
    return out;
  }
  /* their shapes, once; then the section draws again */
  function want(s) {
    var m = M();
    if (!m) { if (later.indexOf(s) < 0 && PIC.test(s)) later.push(s); return; }
    if (asked[s] || !m.maybe(s)) return;
    asked[s] = 1;
    jobs.push(m.need(s).then(function () { if (G.TTAccTextReady) G.TTAccTextReady(); }, function () {}));
  }
  function lay(cx, s, size) {
    var rs = runs(s), w = 0, items = [], e = false;
    rs.forEach(function (r) {
      if (r.t === "e") { items.push({ e: r.name, x: w }); w += size * ADV; e = true; }
      else { items.push({ t: r.s, x: w }); w += cx.measureText(r.s).width; }
    });
    return { items: items, w: w, e: e };
  }
  function write(cx, s, x, y, size, keyline) {
    s = String(s == null ? "" : s);
    want(s);
    var L = lay(cx, s, size), m = M();
    if (!L.e) {
      var t = L.items.map(function (i) { return i.t; }).join("");
      if (keyline) cx.strokeText(t, x, y); else cx.fillText(t, x, y);
      return;
    }
    var align = cx.textAlign, x0 = x - L.w / 2;
    cx.textAlign = "left";
    L.items.forEach(function (i) {
      if (i.e) { if (!keyline && m) m.draw(cx, i.e, x0 + i.x + size * (ADV - SIZE) / 2, y - size * SIZE / 2, size * SIZE); }
      else if (keyline) cx.strokeText(i.t, x0 + i.x, y);
      else cx.fillText(i.t, x0 + i.x, y);
    });
    cx.textAlign = align;
  }
  function halves(s) {
    var m = M(), toks = [];
    (m ? m.split(String(s), letter) : [{ t: "x", s: String(s) }]).forEach(function (r) {
      if (r.t === "e") toks.push(r.src); else toks.push.apply(toks, Array.from(r.s));
    });
    var mid = Math.ceil(toks.length / 2);
    return [toks.slice(0, mid).join(""), toks.slice(mid).join("")];
  }
  G.TTAccText = {
    fill: function (cx, s, x, y, size) { write(cx, s, x, y, size, false); },
    stroke: function (cx, s, x, y, size) { write(cx, s, x, y, size, true); },
    halves: halves,
    ready: function () { return Promise.all(jobs.slice()); }
  };
  /* texts drawn before the emoji runtime was here */
  if (G.addEventListener) G.addEventListener("load", function () { later.splice(0).forEach(want); });
})(typeof self !== "undefined" ? self : this);
